import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    themes: {
      light: {
        primary: '#2f5578',
        secondary: '#00c2f3',
        accent: '#e0e0e0',
        error: '#f44336',
        warning: '#fff3cd',
        info: '#2196f3',
        success: '#4caf50',
        light: '#fff',
        dark: '#333c45'
      }
    }
  }
})
